/* eslint-disable @typescript-eslint/ban-ts-ignore */

import React, { useContext } from "react";

import { ElementState, Preview } from "@creatomate/preview";

import { ElementSource } from "chq";
// @ts-ignore
import { signUpload } from "@culturehq/client";
import { ImageField, VideoField } from "@culturehq/components";
import { MediaFieldValue } from "@culturehq/components/dist/components/form/MediaField";

import { useAWSUpload } from "app/hooks";
import { errorService, getSubdomain, t } from "app/utils";

import { CreatomateContext } from "components/stories/video-studio/contexts/VideoStudioContext";
import { IMAGE_TYPE, VIDEO_TYPE } from "components/stories/video-studio/utils/constants";
import { removeSubtitlesElements } from "../subtitle/utils";

interface ReplaceMediaProps {
  element: ElementState;
  handleMediaUploaded: (modifications: Record<string, any>) => {};
  onUploading: (value: boolean) => void;
  preview: Preview;
  uploading: boolean;
}

const ReplaceMedia: React.FC<ReplaceMediaProps> = ({
  element, handleMediaUploaded, onUploading, preview, uploading
}) => {
  const context = useContext(CreatomateContext);
  const { data: { subtitles }, handleUpdateData } = context;

  const { waitForS3 } = useAWSUpload();

  const uploadMedia = async (media: File) => {
    if (!uploading) {
      onUploading(true);
      const tempUrl = `https://${getSubdomain()}.culturehq.com/${Date.now()}`;
      try {
        await preview.cacheAsset(tempUrl, media);
        await preview.applyModifications({
          [`${element.source.id}.source`]: tempUrl,
          [`${element.source.id}.name`]: `media-${media.name}`
        });
      } catch (error) {
        errorService.error(`Error caching the file: ${error}`);
      }
      const elementId = element.source.id;
      onUploading(false);
      handleUpdateData({ uploadingMedia: true });
      const mediaUrl = await signUpload(media, (_mediaProgress: number) => {});
      await waitForS3(2000, { [`${elementId}.source`]: mediaUrl }, handleMediaUploaded);
    }
  };

  const handleOnMediaChange = async (
    media: MediaFieldValue,
    _thumb: MediaFieldValue,
    _gifUrl: MediaFieldValue,
    _duration?: number,
    finalVersion?: boolean
  ) => {
    if (media && media instanceof File && media.type.startsWith(VIDEO_TYPE) && finalVersion) {
      const creatomateJson = preview.getSource();
      const video = creatomateJson.elements.find((element: ElementSource) => element.type === VIDEO_TYPE && element.name.startsWith("media-"));
      handleUpdateData({ blockSubtitles: true, originalReplacedVideo: video.source });
      await removeSubtitlesElements(handleUpdateData, preview, subtitles, true);

      await uploadMedia(media);
    }
  };

  const handleOnImageChange = async (media: MediaFieldValue, finalVersion: boolean) => {
    if (media && media instanceof File && media.type.startsWith(IMAGE_TYPE) && finalVersion) {
      await uploadMedia(media);
    }
  };

  if (element?.source?.type === VIDEO_TYPE) {
    return (
      <VideoField
        buttonLabel={t("Replace Video")}
        icon="video-camera-filled-complete"
        className="MediaField"
        name="video-field"
        value={element.source.source}
        onChange={handleOnMediaChange}
        imageAsBackground
      >
        <></>
      </VideoField>
    );
  }

  return (
    <ImageField
      buttonLabel={t("Replace Image")}
      icon="image"
      className="MediaField"
      name="image-field"
      value={element.source.source}
      onChange={handleOnImageChange}
      imageAsBackground
    >
      <></>
    </ImageField>
  );
};

export default ReplaceMedia;
